package navigation.home.messages

import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val messageModule
    get() = module {
        factoryOf(::AllConversationScreenModel)
        factoryOf(::ChatScreenModel)
    }